const BROWSER_SCREENSHOT_TOOL_NAMES = new Set([
  'browser_take_screenshot',
  'take_browser_screenshot',
]);

export const isBrowserScreenshotTool = (toolName) =>
  BROWSER_SCREENSHOT_TOOL_NAMES.has(toolName);

const imagePayloadToUrl = (payload) => {
  if (typeof payload === 'string') {
    return payload.startsWith('data:image/') ? payload : null;
  }

  if (!payload || typeof payload !== 'object') return null;

  const data = payload.data;
  if (payload.image_type === 'url' && typeof data === 'string') {
    return data.startsWith('https://') ||
      data.startsWith('http://') ||
      data.startsWith('data:image/')
      ? data
      : null;
  }

  const mediaType = payload.media_type || payload.mediaType;
  if (
    typeof mediaType === 'string' &&
    mediaType.startsWith('image/') &&
    typeof data === 'string' &&
    data.length > 0
  ) {
    return `data:${mediaType};base64,${data}`;
  }

  return null;
};

/**
 * Normalize image blocks from both live AgentEvents and persisted tool results.
 */
export const extractImageUrls = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.flatMap(extractImageUrls);
  }

  const directUrl = imagePayloadToUrl(value);
  if (directUrl) return [directUrl];

  if (typeof value === 'object') {
    return [
      ...extractImageUrls(value.images),
      ...extractImageUrls(value.content),
      ...extractImageUrls(value.source),
    ];
  }

  return [];
};

export const firstImageUrl = (value) => extractImageUrls(value)[0] || null;
